export function actionToObject (json) {
  try {
    return JSON.parse(json)
  } catch (e) {
    console.log('err', e.message)
  }
  return []
}


export function hasRoleCode(roleCode) {
  // 1. 从localStorage获取角色数据
  const roleData = localStorage.getItem('roleCodes');
  if (!roleData) return false;

  // 2. 解析JSON字符串为数组
  try {
    const roleCodes = JSON.parse(roleData);

    // 3. 检查目标角色是否存在
    return roleCodes.includes(roleCode);
  } catch (e) {
    console.error('角色数据解析失败:', e);
    return false;
  }
}